import React, { useState } from "react";
import { Sketch } from "@uiw/react-color";
import {
  createOrganisation,
  updateOrganisation,
} from "../../services/organisation";
import toast from "react-hot-toast";

const formatDateForInput = (dateString) => {
  if (!dateString) return "";
  return dateString.split("T")[0];
};

const CreateDomain = ({ onClose, organisation }) => {
  const [name, setName] = useState(() => organisation?.name || "");
  const [domain, setDomain] = useState(() => organisation?.domain || "");
  const [primaryColor, setPrimaryColor] = useState(
    () => organisation?.primaryColor || "#22c55e"
  );
  const [secondaryColor, setSecondaryColor] = useState(
    () => organisation?.secondaryColor || "#22c55e"
  );
  const [logo, setLogo] = useState(() => organisation?.logo || "");
  const [favIcon, setFavIcon] = useState(() => organisation?.favIcon || "");
  const [email, setEmail] = useState(() => organisation?.email || "");
  const [dateCreated, setDateCreated] = useState(
    formatDateForInput(organisation?.dateCreated) ||
      new Date().toISOString().split("T")[0]
  );
  const [dateUpdated, setDateUpdated] = useState(
    formatDateForInput(organisation?.dateUpdated) ||
      new Date().toISOString().split("T")[0]
  );
  const [isDefault, setIsDefault] = useState(organisation?.isDefault ?? true);
  const [firstName, setFirstName] = useState(organisation?.firstName || "");
  const [lastName, setLastName] = useState(organisation?.lastName || "");
  const [phoneNumber, setPhoneNumber] = useState(
    organisation?.phoneNumber || ""
  );
  const [loading, setLoading] = useState(false);

  const isEditMode = Boolean(organisation);

  const isReadOnly = isEditMode;

  const createDomain = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = isEditMode
        ? await updateOrganisation({
            organisationId: organisation.id,
            name,
            domain,
            primaryColor,
            secondaryColor,
            logo,
            favIcon,
            email,
          })
        : await createOrganisation({
            name,
            domain,
            primaryColor,
            secondaryColor,
            logo,
            favIcon,
            email,
            dateCreated,
            dateUpdated,
            isDefault,
            firstName,
            lastName,
            phoneNumber,
          });
      toast.success(res.message);
      onClose();
    } catch (error) {
      if (error.response) {
        toast.error(error?.response?.data?.message);
        setLoading(false);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="fixed inset-0 bg-black/40 z-[900]" onClick={onClose} />
      <div className="flex flex-col justify-center overflow-hidden  absolute top-0 right-0 z-[1000] bg-white shadow rounded-md p-4">
        <div className="bg-white w-[350px] p-4">
          <div className="flex items-center justify-between">
            <h1 className="text-[20px] font-bold text-navy-blue">
              {isEditMode ? "Edit Domain" : "Create Domain"}
            </h1>
            <button
              className="flex justify-center text-[#E71D36] bg-[#E71D36]/20 rounded-3xl w-[30px] h-[30px]"
              onClick={onClose}
            >
              x
            </button>
          </div>
          <form className="flex flex-col mt-4" onSubmit={createDomain}>
            <div className="flex flex-col mt-2">
              <label id="name">Name</label>
              <input
                name="name"
                type="text"
                value={name}
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="flex flex-col mt-2">
              <label id="domain">Domain</label>
              <input
                name="domain"
                type="text"
                value={domain}
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                onChange={(e) => setDomain(e.target.value)}
                required
              />
            </div>
            <div className="flex flex-col mt-2 bg-white p-4 rounded-lg shadow">
              <label>Primary Color</label>
              <Sketch
                color={primaryColor}
                onChange={(color) => {
                  setPrimaryColor(color.hex);
                }}
              />
            </div>
            <div className="flex flex-col mt-2 bg-white p-4 rounded-lg shadow">
              <label>Secondary Color</label>
              <Sketch
                color={secondaryColor}
                onChange={(color) => {
                  setSecondaryColor(color.hex);
                }}
              />
            </div>

            <div className="flex flex-col mt-2">
              <label id="logo">Logo</label>
              <input
                name="logo"
                type="text"
                value={logo}
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                onChange={(e) => setLogo(e.target.value)}
                required
              />
            </div>
            <div className="flex flex-col mt-2">
              <label id="logo">Favicon</label>
              <input
                name="logo"
                type="text"
                value={favIcon}
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                onChange={(e) => setFavIcon(e.target.value)}
                required
              />
            </div>
            <div className="flex flex-col mt-2">
              <label id="email">Email</label>
              <input
                name="email"
                type="email"
                value={email}
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="flex flex-col mt-2">
              <label id="date-created">Date Created</label>
              <input
                name="date-created"
                type="date"
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                value={dateCreated}
                disabled={isReadOnly}
                onChange={(e) => setDateCreated(e.target.value)}
                required
              />
            </div>
            <div className="flex flex-col mt-2">
              <label id="date-updated">Date Updated</label>
              <input
                name="date-updated"
                type="date"
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                value={dateUpdated}
                disabled={isReadOnly}
                onChange={(e) => setDateUpdated(e.target.value)}
                required
              />
            </div>
            <div className="flex items-center gap-1 mt-2">
              <label id="isDefault">isDefault</label>
              <input
                name="isDefault"
                type="checkbox"
                className="mt-1"
                checked={isDefault}
                disabled={isReadOnly}
                onChange={(e) => setIsDefault(e.target.checked)}
              />
            </div>
            <div className="flex flex-col mt-2">
              <label id="firstName">First Name</label>
              <input
                name="firstName"
                type="text"
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                value={firstName}
                disabled={isReadOnly}
                onChange={(e) => setFirstName(e.target.value)}
                required
              />
            </div>
            <div className="flex flex-col mt-2">
              <label id="lastName">Last Name</label>
              <input
                name="lastName"
                type="text"
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                value={lastName}
                disabled={isReadOnly}
                onChange={(e) => setLastName(e.target.value)}
                required
              />
            </div>
            <div className="flex flex-col mt-2">
              <label id="number">Phone Number</label>
              <input
                name="number"
                type="text"
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                value={phoneNumber}
                disabled={isReadOnly}
                onChange={(e) => setPhoneNumber(e.target.value)}
                required
              />
            </div>
            <div className="mt-2">
              <button
                type="submit"
                className="w-full h-[50px] bg-primary text-white text-base font-semibold rounded-md"
              >
                {loading
                  ? isEditMode
                    ? "Updating..."
                    : "Creating..."
                  : isEditMode
                  ? "Edit Domain"
                  : "Create Domain"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default CreateDomain;
